// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SubnodeOutlinedSvg from "@ant-design/icons-svg/es/asn/SubnodeOutlined";
import AntdIcon from '../components/AntdIcon';

var SubnodeOutlined = function SubnodeOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: SubnodeOutlinedSvg
  }));
};

SubnodeOutlined.displayName = 'SubnodeOutlined';
export default React.forwardRef(SubnodeOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/SubnodeOutlined.js
// module id = 1887
// module chunks = 0